import { BookOpenText, Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";

export function LearningTextLesson({
  title,
  focus,
  topics,
}: {
  title: string;
  focus: string;
  topics: string[];
}) {
  const { t } = useTranslation();
  return (
    <section className="overflow-hidden rounded-xl border border-border bg-background">
      <div className="flex items-center gap-4 bg-primary/5 p-5">
        <BookOpenText aria-hidden="true" className="size-12 shrink-0 text-primary" strokeWidth={1.25} />
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-primary">
            {t("passportVig.lesson.formats.text")}
          </p>
          <h4 className="mt-1 text-lg font-medium">{title}</h4>
        </div>
      </div>
      <div className="space-y-5 p-5 sm:p-6">
        <p className="text-base leading-relaxed">{focus}</p>
        {topics.length ? (
          <>
            <h5 className="font-medium">{t("passportVig.lesson.reading.connect")}</h5>
            <p className="text-sm leading-relaxed text-muted-foreground">
              {t("passportVig.lesson.reading.explanation", { topic: topics[0] })}
            </p>
            <ul className="list-disc space-y-2 pl-5 text-sm marker:text-primary">
              {topics.map((topic) => (
                <li key={topic}>{topic}</li>
              ))}
            </ul>
          </>
        ) : null}
        <aside className="flex items-start gap-3 rounded-xl bg-warning p-4 text-warning-foreground">
          <Lightbulb aria-hidden="true" className="mt-0.5 size-5 shrink-0" />
          <div>
            <h5 className="text-sm font-medium">{t("passportVig.lesson.reading.pause")}</h5>
            <p className="mt-1 text-sm leading-relaxed">
              {t("passportVig.lesson.reflectionIntro", { title })}
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}
